import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { getPracticeList } from "../queryFunctions/getPracticeList";
import type { Practice } from "../queryFunctions/getPracticeList";
import { practiceKeys } from "../keyFactory";

type UsePracticeListProps<TData = Practice[]> = {
  select?: (data: Practice[]) => TData;
};

type PracticeListQueryOptions = UseQueryOptions<
  Practice[],
  unknown,
  Practice[],
  ReturnType<typeof practiceKeys.list>
>;

function optionFactory() {
  return {
    queryFn: getPracticeList,
    queryKey: practiceKeys.list(),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies PracticeListQueryOptions;
}

export function usePracticeList<TData = Practice[]>({ select }: UsePracticeListProps<TData> = {}) {
  return useQuery({ ...optionFactory(), select });
}
